import { render, staticRenderFns } from "./SalaryReport.vue?vue&type=template&id=597de79a"
import script from "./SalaryReport.vue?vue&type=script&lang=js"
export * from "./SalaryReport.vue?vue&type=script&lang=js"
import style0 from "./SalaryReport.vue?vue&type=style&index=0&id=597de79a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports